import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

var queryParam = {
  chatOnly: 'on',
  date: [getBeforeDate('1_month'), new Date().toISOString().slice(0, 10)]
}
const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const getUsedBy = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const usedByItem = searchFormConfig.formItems.find(item => item.field === 'usedBy');
  usedByItem!.options = userOptions;
}
getUsedBy()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData.value)
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const getDeptName = (row: any) => {
  if (row.parentDeptName == '江苏天鼎证券投资咨询有限公司') {
    return '江苏天鼎' + '-' + row.deptName
  }
  return row.parentDeptName + '-' + row.deptName
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/soMsg/queryExportData', queryInfo)
}

const handleSoMsg = (item: any) => {
  getExportData().then((res) => {
    let customHeader = [
      '账号',
      '使用人',
      '使用人部门',
      '接收人',
      '时间',
      '内容'
    ]
    let header = [
      'sname',
      'usedBy',
      'deptName',
      'uname',
      'msgTimeStr',
      'content'
    ]
    let exportData: any = []
    res.forEach((item: any) => {
      let obj = {
        sname: '',
        usedBy: '',
        deptName: '',
        uname: '',
        msgTimeStr: '',
        content: ''
      }
      obj.sname = item.sname + '(' + item.sid + ')'
      obj.usedBy = item.usedBy
      obj.deptName = getDeptName(item)
      obj.uname = item.uname + '(' + item.uremark + ')'
      obj.msgTimeStr = item.msgTimeStr
      obj.content = item.content
      exportData.push(obj)
    })
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '股票跟踪消息统计-' + filename,
      title: '股票跟踪消息统计-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "soMsg",
      onDownBtnClick: handleSoMsg,
      onSortChange: handleSortChange
    }, {
      sname: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.sname + '(' + scope.row.sid + ')'), 1)
      ]),
      deptName: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(getDeptName(scope.row)), 1)
      ]),
      content: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: 2,
            placeholder: "请输入内容",
            modelValue: scope.row.content,
            "onUpdate:modelValue": ($event: any) => ((scope.row.content) = $event),
            readonly: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})